import React, { Component } from 'react';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import { reduce, isNumber, isString, isArray, first, last, each } from 'lodash';
import moment from 'moment';
import { Button, PanelGroup, Panel, Modal } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import CustomDateRangeField from './custom-date-range-field';
import masterField from './master-field';
import PredefinedRangeSelector from './predefined-range-selector';
import MinMaxForm from './min-max-form';
import { getPredefineDateRanges } from '../../util/helpers';

const format = 'YYYY-MM-DD';
const displayFormat = 'MMM DD, YYYY';


const MODE_PREDEFINED_RANGES = 'pre_defined_range';
const MODE_CUSTOM_RANGES = 'custom_range';
const MODE_RELATIVE_RANGES = 'relative_range';


const detectControlType = (value) => {
  if (isString(value)) {
    // slug
    const predefinedRanges = getPredefineDateRanges();
    let v = null;
    each(predefinedRanges, (predefinedRange) => {
      if (!v) {
        v = first(predefinedRange.ranges, { slug: value });
      }
    });
    if (v) {
      return {
        value,
        mode: MODE_PREDEFINED_RANGES,
      };
    }
    return null;
  }
  
  if (isArray(value) && (isNumber(first(value)) || isNumber(last(value)))) {
    const vals = [];
    if (isNumber(first(value))) {
      vals.push(first(value));
    } else {
      vals.push(null);
    }
    if (isNumber(last(value))) {
      vals.push(last(value));
    } else {
      vals.push(null);
    }
    return {
      value: vals,
      mode: MODE_RELATIVE_RANGES,
    };
  }

  if (isArray(value) && (isString(first(value)) || isString(last(value)))) {
    const vals = [];
    const start = first(value) ? moment(first(value), format) : null;
    const end = last(value) ? moment(last(value), format) : null;

    if (start && start.isValid()) {
      vals.push(start.format(format));
    } else {
      vals.push(null);
    }
    if (end && end.isValid()) {
      vals.push(end.format(format));
    } else {
      vals.push(null);
    }
    return {
      value: vals,
      mode: MODE_CUSTOM_RANGES,
    };
  }

  return null;
}
class DateRangeField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: null,
      openModal: false,
      predefinedRanges: getPredefineDateRanges(),
      values: [null, null],
      selectedRanges: [],
      mainLabel: null,
      subLabel: null,
    };
    this.handleEditModeSelect = this.handleEditModeSelect.bind(this);
    this.selectDateRange = this.selectDateRange.bind(this);
    this.onRelativeRangeChange = this.onRelativeRangeChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.initEditMode();
  }

  shoudlLog() {
    const tId = 'JfueT8H_d';
    const cId = this.props.searchCriteria._id;
    return tId === cId;
  }

  selectDateRange(range, autoClose = true) {
    const { path } = this.props;
    if (autoClose) {
      // this.setState({ openModal: false });
      // this.props.onModalHide();
    }
    let selectedRanges = null;

    if (range.slug) {
      const { predefinedRanges } = this.state;
      selectedRanges = reduce(predefinedRanges, (items, predefinedRange) => {
        const ranges = reduce(predefinedRange.ranges, (rangeItems, r) => {
          if (r.slug === range.slug) {
            rangeItems.push(r);
          }
          return rangeItems;
        }, []);
        if (ranges.length) {
          items.push({ ...predefinedRange, ranges });
        }
        return items;
      }, []);
    }
    const values = range.slug ? range.slug : [range.start, range.end];
    const controlType = range.slug ? MODE_PREDEFINED_RANGES : MODE_CUSTOM_RANGES;
    const labels = this.getLabels(controlType, values);

    this.setState({
      values,
      ...(selectedRanges ? { selectedRanges } : {}),
      ...labels,
    }, () => {
      this.props.onUpdate(
        path,
        {
          values: range.slug ? range.slug : [range.start, range.end],
          start: range.start,
          end: range.end,
          labels,
          control_type: controlType,
        },
      );
    });
  }

  convertDatesToRelativeMinMax(rawMinDate, rawMaxDate) {
    let minRelative = null;
    let maxRelative = null;
    const now = moment().startOf('day');
    const minDate = rawMinDate ? moment(rawMinDate, format) : null;
    const maxDate = rawMaxDate ? moment(rawMaxDate, format) : null;
    if (moment.isMoment(minDate) && minDate.isValid()) {
      minRelative = Math.trunc(parseFloat(minDate.startOf('day').diff(now, 'days'), 10));
    }
    if (moment.isMoment(maxDate) && maxDate.isValid()) {
      maxRelative = Math.trunc(parseFloat(maxDate.startOf('day').diff(now, 'days'), 10));
    }
    return {
      values: [minRelative, maxRelative],
      start: moment.isMoment(minDate) && minDate.isValid() ? minDate.format(format) : null,
      end: moment.isMoment(maxDate) && maxDate.isValid() ? maxDate.format(format) : null,
    };
  }

  convertPredefineDateRanges(values) {
    const { predefinedRanges } = this.state;
    const selectedRanges = reduce(predefinedRanges, (items, predefinedRange) => {
      const ranges = reduce(predefinedRange.ranges, (rangeItems, range) => {
        if (range.slug === values) {
          rangeItems.push(range);
        }
        return rangeItems;
      }, []);
      if (ranges.length) {
        items.push({ ...predefinedRange, ranges });
      }
      return items;
    }, []);
    return selectedRanges;
  }

  convertDateRangeToPredefineRange(minVal, maxVal) {
    const { predefinedRanges } = this.state;
    const selectedRanges = reduce(predefinedRanges, (items, predefinedRange) => {
      const ranges = reduce(predefinedRange.ranges, (rangeItems, range) => {
        if (range.start === minVal && range.end === maxVal) {
          rangeItems.push(range);
        }
        return rangeItems;
      }, []);
      if (ranges.length) {
        items.push({ ...predefinedRange, ranges });
      }
      return items;
    }, []);
    return selectedRanges;
  }

  convertMinMaxToDates(minVal, maxVal) {
    let minDate = null;
    let maxDate = null;
    const now = moment().startOf('day');
    
    if (isNumber(minVal)) {
      minDate = now.clone().add(minVal, 'days').startOf('day');
    }
    if (isNumber(maxVal)) {
      maxDate = now.clone().add(maxVal, 'days').startOf('day');
    }
    const range = {
      values: [minVal, maxVal],
      start: minDate && minDate.isValid() ? minDate.format('YYYY-MM-DD') : null,
      end: maxDate && maxDate.isValid() ? maxDate.format('YYYY-MM-DD') : null,
    };
    return range;
  }

  initEditMode() {
    if (!this.props.searchCriteria?.control_type) {
      const d = detectControlType(this.props.searchCriteria.values);
      if (d) {
        this.props.searchCriteria.values = d.value;
        this.props.searchCriteria.control_type = d.mode;
        this.handleEditModeSelect(d?.mode);
      }
    } else {
      const mode = this.props.searchCriteria?.control_type || MODE_PREDEFINED_RANGES;
      this.handleEditModeSelect(mode);
    }
  }

  toggleModal() {
    const { openModal } = this.state;
    const { disabled } = this.props;
    if (!disabled) {
      if (openModal) {
        this.props.onModalHide();
        this.setState({
          openModal: false,
        });
      } else {
        this.initEditMode();
        this.setState({
          openModal: !openModal,
        });
        this.props.onModalShow();
      }
    }
  }

  closeModal() {
    this.toggleModal()
  }

  onRelativeRangeChange(mnV, mxV) {
    const { path } = this.props;
    const minVal = isNumber(mnV) ? Math.trunc(mnV) : null;
    const maxVal = isNumber(mxV) ? Math.trunc(mxV) : null;
    const range = this.convertMinMaxToDates(minVal, maxVal);
    const labels = this.getLabels(MODE_RELATIVE_RANGES, range.values);
    this.setState({
      values: range.values,
      ...labels,
    }, () => {
      this.props.onUpdate(path, {
        ...range,
        labels,
        control_type: MODE_RELATIVE_RANGES,
      });
    });
  }

  handleEditModeSelect(mode) {
    if (mode === this.state.mode) {
      return;
    }
    const { path } = this.props;
    const currentValues = this.props.searchCriteria?.values;
    const currentControlType = this.props.searchCriteria?.control_type;

    if (!mode) {
      /*
      this.setState({ mode, openModal: false }, () => {
        this.props.onModalHide();
      });
      */
      // this.setState({ mode });
      // Do nothing
    } else if (mode === MODE_PREDEFINED_RANGES) {
      let values = [null, null];
      let selectedRanges = [];
      if (this.state.mode === MODE_CUSTOM_RANGES) {
        selectedRanges = this.convertDateRangeToPredefineRange(currentValues[0], currentValues[1]);
      } else if (this.state.mode === MODE_RELATIVE_RANGES) {
        const r = this.convertMinMaxToDates(currentValues[0], currentValues[1]);
        selectedRanges = this.convertDateRangeToPredefineRange(r.start, r.end);
      } else if (this.state.mode === null && (!currentControlType || currentControlType === MODE_PREDEFINED_RANGES)) {
        selectedRanges = this.convertPredefineDateRanges(currentValues);
      }
      const selectedRange = selectedRanges && selectedRanges.length > 0 ? selectedRanges[0] : null;
      const ranges = selectedRange ? selectedRange.ranges : null;
      values = ranges && ranges.length > 0 ? ranges[0].slug : null; 
      const labels = this.getLabels(mode, values);
      this.setState({ mode, values, selectedRanges, ...labels }, () => {
        this.props.onUpdate(
          path,
          {
            values,
            labels,
            start: ranges && ranges.length > 0 ? ranges[0].start : null,
            end: ranges && ranges.length > 0 ? ranges[0].end : null,
            control_type: mode,
          },
        );
      });
    } else if (mode === MODE_CUSTOM_RANGES) {
      let values = [null, null];
      let range = null;

      if (this.state.mode === MODE_PREDEFINED_RANGES) {
        const selectedRanges = this.convertPredefineDateRanges(currentValues);
        const ranges = selectedRanges.length > 0 ? selectedRanges[0]?.ranges : [];
        values = ranges && ranges.length > 0 ? [ranges[0].start, ranges[0].end] : [null, null];
        range = ranges && ranges.length > 0 ? ranges[0] : null;
      } else if (this.state.mode === MODE_RELATIVE_RANGES) {
        const r = this.convertMinMaxToDates(currentValues[0], currentValues[1]);
        values = [r.start, r.end];
        range = r;
      } else if (!this.state.mode && currentControlType === MODE_CUSTOM_RANGES) {
        values = [...currentValues];
        range = this.convertDatesToRelativeMinMax(...values);
      }
      const labels = this.getLabels(mode, values);
      this.setState({ mode, values, ...labels }, () => {
        this.props.onUpdate(
          path,
          {
            values,
            labels,
            start: range ? range.start : null,
            end: range ? range.end : null,
            control_type: mode,
          },
        );
      });
    } else if (mode === MODE_RELATIVE_RANGES) {
      let values = [null, null];
      let range = null;
      if (this.state.mode === MODE_PREDEFINED_RANGES) {
        const selectedRanges = this.convertPredefineDateRanges(currentValues);
        const selectedRange = selectedRanges.length > 0 ? selectedRanges[0] : null;
        const ranges = selectedRange ? selectedRange.ranges : [];
        range = ranges && ranges.length > 0 ? this.convertDatesToRelativeMinMax(ranges[0].start, ranges[0].end) : null;
        values = range ? range.values : [null, null];
      } else if (this.state.mode === MODE_CUSTOM_RANGES) {
        range = currentValues && currentValues.length > 0 ? this.convertDatesToRelativeMinMax(currentValues[0], currentValues[1]) : null;
        values = range ? range.values : [null, null];
      } else if (!this.state.mode && currentControlType === MODE_RELATIVE_RANGES) {
        values = [...currentValues];
        range = this.convertMinMaxToDates(...values);
      }
      const labels = this.getLabels(mode, values);
      this.setState({ mode, values, ...labels }, () => {
        this.props.onUpdate(
          path,
          {
            values,
            labels,
            start: range ? range.start : null,
            end: range ? range.end : null,
            control_type: mode,
          },
        );
      });
    }
  }

  getRelativeLabel(minVal, maxVal) {
    if (minVal === null && maxVal === null) {
      return null;
    }
    if (minVal === maxVal && minVal === 0) {
      return (
        <span>
          is exactly <strong>today</strong>
        </span>
      );  
    }
    const [suffixMin, suffixMax] = this.getMinMaxSuffixes(minVal, maxVal);
    let label = null;
    let minNum = minVal ? Math.abs(minVal) : null;
    let maxNum = maxVal ? Math.abs(maxVal) : null;
    if (minNum === 1) {
      minNum = 'one'
    }
    if (maxNum === 1) {
      maxNum = 'one'
    }
    if (minVal !== null && maxVal !== null) {
      if (minVal === maxVal) {
        label = (
          <span>is exactly <strong>{minNum} {suffixMin}</strong></span>
        );
      } else {
        label = (
          <span>
            from <strong>{minNum} {suffixMin}</strong> to <strong>{maxNum} {suffixMax}</strong>
          </span>
        );
      }
    } else if (minVal !== null && maxVal === null) {
      label = (
        <span>
          starting from <strong>{minNum} {suffixMin}</strong>
        </span>
      );
    } else if (minVal === null && maxVal !== null) {
      label = (
        <span>
          up until <strong>{maxNum} {suffixMax}</strong>
        </span>
      );
    }

    return label;
  }

  getLabels(mode, values) {
    const { searchCriteria: { filter: { label } } } = this.props;
    const defaultLabel = `Select a date range for ${label}`;

    let startDate = null;
    let endDate = null;
    let mainLabel = null;
    let subLabel = null;

    if (mode === MODE_PREDEFINED_RANGES && isString(values)) {
      const selectedRanges = this.convertPredefineDateRanges(values);
      const selectedRange = first(selectedRanges);
      const firstRange = selectedRange ? first(selectedRange.ranges) : null;
      if (firstRange) {
        if (firstRange.displayLabel) {
          mainLabel = firstRange.displayLabel;
        } else {
          mainLabel = `${selectedRange.label} ${firstRange.label}`;
        }
        const s = firstRange.start ? moment(firstRange.start, format) : null;
        const e = firstRange.end ? moment(firstRange.end, format) : null;
        if (s && s.isValid()) {
          startDate = s;
        }
        if (e && e.isValid()) {
          endDate = e;
        }
      }
    } else if (mode === MODE_CUSTOM_RANGES && isArray(values)) {
      const s = values[0] ? moment(values[0], format) : null;
      const e = values[1] ? moment(values[1], format) : null;
      if (s && s.isValid()) {
        startDate = s;
      }
      if (e && e.isValid()) {
        endDate = e;
      }
    } else if (mode === MODE_RELATIVE_RANGES && isArray(values)) {
      mainLabel = this.getRelativeLabel(values[0], values[1]);
      const r = this.convertMinMaxToDates(values[0], values[1]);
      const s = r.start ? moment(r.start, format) : null;
      const e = r.end ? moment(r.end, format) : null;
      if (s && s.isValid()) {
        startDate = s;
      }
      if (e && e.isValid()) {
        endDate = e;
      }
    }

    if (startDate && endDate) {
      if (startDate.isSame(endDate, 'day')) {
        subLabel = (
          <span>
            {mode === MODE_RELATIVE_RANGES ? '' : 'is on '} <strong>{startDate.format(displayFormat)}</strong>
          </span>
        );
      } else {
        subLabel = (
          <span>
            from <strong>{startDate.format(displayFormat)}</strong> to <strong>{endDate.format(displayFormat)}</strong>
          </span>
        );
      }
    } else if (startDate && !endDate) {
      subLabel = (
        <span>
          starting from <strong>{startDate.format(displayFormat)}</strong>
        </span>
      );
    } else if (!startDate && endDate) {
      subLabel = (
        <span>
          up until <strong>{endDate.format(displayFormat)}</strong>
        </span>
      );
    }


    return {
      mainLabel: mainLabel || subLabel || defaultLabel,
      subLabel: mainLabel ? subLabel : null,
    };
  }
  
  renderPanelHeader(mode, title) {
    const isActive = mode === this.state.mode;
    return (
      <Panel.Heading>
        <Panel.Title>
          <Panel.Toggle componentClass="div" style={{ cursor: 'pointer' }}>
            <table>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: 'top', paddingRight: 10 }} className="text-center"><Fa name={isActive ? 'check-square' : 'square-o'} className={isActive ? 'text-active' : 'text-muted'} /></td>
                  <td width="99%" className={isActive ? 'text-active' : ''}>{title}</td>
                  <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                </tr>
              </tbody>
            </table>
          </Panel.Toggle>
        </Panel.Title>
      </Panel.Heading>
    );
  }

  renderPredefinedRangesPanel() {
    const { selectedRanges, mode } = this.state;
    const { includeFuturePredefinedRanges } = this.props;
    return (
      <Panel style={{ margin: '0px' }} eventKey={MODE_PREDEFINED_RANGES}>
        {this.renderPanelHeader(MODE_PREDEFINED_RANGES, 'Select a predefined date range')}
        <Panel.Body collapsible>
          {mode === MODE_PREDEFINED_RANGES &&
            <PredefinedRangeSelector
              selectedRanges={selectedRanges}
              selectRange={this.selectDateRange}
              includeFuturePredefinedRanges={includeFuturePredefinedRanges}
            />
          }
        </Panel.Body>
      </Panel>
    );
  }

  renderCustomRangesPanel() {
    const { values, mode } = this.state;
    const { disabled } = this.props;
    return (
      <Panel style={{ margin: '0px' }} eventKey={MODE_CUSTOM_RANGES}>
        {this.renderPanelHeader(MODE_CUSTOM_RANGES, 'Enter a custom date range')}
        <Panel.Body collapsible>
          {mode === MODE_CUSTOM_RANGES && 
            <CustomDateRangeField
              disabled={disabled}
              start={values[0]}
              end={values[1]}
              onSelect={(start, end) => {
                this.selectDateRange({ start, end }, false);
              }}
            />
          }
        </Panel.Body>
      </Panel>
    );
  }


  getMinMaxSuffixes(minRelative, maxRelative) {
    let suffixMin = null;
    let suffixMax = null;
    if (minRelative !== null) {
      if (minRelative === 0) {
        suffixMin = 'today';
      } else {
        suffixMin = `${pluralize('day', minRelative)} ${(minRelative > 0 ? 'after' : 'before')} today`;
      }
    }
    if (maxRelative !== null) {
      if (maxRelative === 0) {
        suffixMax = 'today';
      } else {
        suffixMax = `${pluralize('day', maxRelative)} ${(maxRelative > 0 ? 'after' : 'before')} today`;
      }
    }
    return [suffixMin, suffixMax];
  }

  renderRelativeRangesPanel() {
    const { disabled, searchCriteria } = this.props;
    const { mode } = this.state;

    const isActive = mode === MODE_RELATIVE_RANGES;

    let comp = null;

    if (isActive) {
      const values = isArray(this.state.values) ? this.state.values : [null, null];
      const newSearchCriteria = {
        _id: searchCriteria._id,
        values: [...values],
        filter: {
          ...searchCriteria.filter,
          meta: {
            type: 'int',
          },
        },
        control_type: MODE_RELATIVE_RANGES,
      };

      const [suffixMin, suffixMax] = this.getMinMaxSuffixes(values[0], values[1]);

      comp = (
        <MinMaxForm
          disabled={disabled}
          suffixMin={suffixMin}
          suffixMax={suffixMax}
          suffixIsUnit={false}
          searchCriteria={newSearchCriteria}
          onUpdate={this.onRelativeRangeChange}
        />
      )
    }
    
    return (
      <Panel style={{ margin: '0px' }} eventKey={MODE_RELATIVE_RANGES}>
        {this.renderPanelHeader(MODE_RELATIVE_RANGES, 'Enter a date range relative to today')}
        <Panel.Body collapsible>
          {isActive && comp}
        </Panel.Body>
      </Panel>
    );
  }

  renderDebug() {
    const {
      selectedRanges,
    } = this.state;
    return (
      <div>
        <hr />
        <div>
          <div>props:</div>
          <pre>{JSON.stringify(selectedRanges, null, 2)}</pre>
        </div>
      </div>
    );
  }

  render() {
    const { mode, openModal, mainLabel, subLabel } = this.state;
    const { disabled, searchCriteria: { filter: { label } } } = this.props;

    return (
      <div>
        <div>
          {disabled && <strong>{mainLabel}</strong>}
          {!disabled &&
            <a
              className="clickable"
              disabled={disabled}
              onClick={ (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleModal();
              }}
            >
              {mainLabel}
            </a>
          }
          {subLabel !== null && <small>&nbsp;({subLabel})</small>}
        </div>
        <Modal key="modal" show={openModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="well well-sm">{label}: {mainLabel}</div>
              <PanelGroup id="date-selector" activeKey={mode} onSelect={this.handleEditModeSelect} accordion>
                {this.renderPredefinedRangesPanel()}
                {this.renderCustomRangesPanel()}
                {this.renderRelativeRangesPanel()}
              </PanelGroup>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="default" onClick={this.closeModal}>Done</Button>
          </Modal.Footer>
        </Modal>
        {this.props.children}
      </div>
    );
  }
}
function mapStateToProps() {
  return {};
}

DateRangeField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onModalShow: PropTypes.func,
  onModalHide: PropTypes.func,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  includeFuturePredefinedRanges: PropTypes.bool,
  searchCriteria: PropTypes.shape({ // eslint-disable-line
    _id: PropTypes.string.isRequired,
    filter: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
    control_type: PropTypes.string,
    values: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(PropTypes.number), // https://github.com/lumen-software/TruSales/issues/1695
    ]),
  }),
  onUpdate: PropTypes.func.isRequired,
  children: PropTypes.node,
};
DateRangeField.defaultProps = {
  onModalShow: () => {},
  onModalHide: () => {},
  disabled: false,
  searchCriteria: null,
  includeFuturePredefinedRanges: false,
  children: null,
};
const Comp = masterField(connect(mapStateToProps)(DateRangeField));

Comp.MODE_PREDEFINED_RANGES = MODE_PREDEFINED_RANGES;
Comp.MODE_CUSTOM_RANGES = MODE_CUSTOM_RANGES;
Comp.MODE_RELATIVE_RANGES = MODE_RELATIVE_RANGES;

Comp.detectControlType = detectControlType;

export default Comp;